import AwsConfig from '../../Config/AwsConfig'
import { personoccupationtelugu } from '../Data/StaticPersonandMoviedata'
import GetFormattedDate from '../Movie/getFormattedDate'

const PersonDataforForm = personData => {
  // setFile('https://upload.wikimedia.org/wikipedia/commons/thumb/1/1a/RamCharan.jpg/220px-RamCharan.jpg')
  const resultDob = GetFormattedDate(
    parseInt(personData.dateOfBirth ? personData.dateOfBirth : '', 10),
  )
  const complexCityreducedPersondata = reduceComplexity(personData)
  const complexCityreducedPersondataSecound = reduceComplexitySecound(personData)
  const inputData1 = {
    dateOfBirth: resultDob,
    spouse_En: complexCityreducedPersondataSecound.spouseEn,
    spouse_Te: complexCityreducedPersondataSecound.spouseTe,
    // complexCityreducedPersondata.translatespouse,
    Relatives_En: complexCityreducedPersondataSecound.relativesEn,
    Relatives_Te: complexCityreducedPersondataSecound.relativesTe,
    // complexCityreducedPersondata.translatedataRelative ,
    Children_En: complexCityreducedPersondata.childrenEn,
    Children_Te: complexCityreducedPersondata.childrenEn,
    AwardWins_En: complexCityreducedPersondataSecound.awardsEn,
    AwardWins_Te: complexCityreducedPersondataSecound.awardsTe,
    // AwardNomi_En: [],
    // AwardNomi_Te: [],
    Almamater_En: complexCityreducedPersondata.almamater,
    Almamater_Te: complexCityreducedPersondata.almamaterte,
    PoliticalParty_En: complexCityreducedPersondata.PoliticalPartyEn,
    PoliticalParty_Te: complexCityreducedPersondata.PoliticalPartyTe,
    occupation: personData.occupation_En ? complexCityreducedPersondata.personDataoccupationEn : [],
    // occupationte: complexCityreducedPersondata.personDataoccupationTe,
    occupationte: complexCityreducedPersondata.occupationte,
    personPoster: complexCityreducedPersondata.posterUrl,
    PlaceofBirthen: complexCityreducedPersondata.PlaceofBirthen,
    PlaceofBirthte: complexCityreducedPersondata.PlaceofBirthte,
    Parents_En: complexCityreducedPersondata.parentsEn,
    Parents_Te: complexCityreducedPersondata.parentsTe,
    Roles_En: complexCityreducedPersondata.RolesEn,
    genRe: complexCityreducedPersondata.genreEn,
    genReTelugu: complexCityreducedPersondata.genreTe,
    GalleryImages: GalleryImages(personData),
    GalleryVideos: GalleryVideos(personData),
    popularPerson: complexCityreducedPersondataSecound.popularPerson,
    GOAT: complexCityreducedPersondataSecound.GOAT,
    popularyKnownAs_En: complexCityreducedPersondataSecound.popularyKnownAsEn,
    popularyKnownAs_Te: complexCityreducedPersondataSecound.popularyKnownAsTe,
    internalComments: personData.internalComments || '',
    spouse_TFIDB: personData.spouse_TFIDB || [],
    parents_TFIDB: personData.parents_TFIDB || [],
    relatives_TFIDB: personData.relatives_TFIDB || [],
    children_TFIDB: personData.children_TFIDB || [],
    instagramLink: personData.instagramLink || '',
    twitterID: personData.twitterID || '',
    age: personData.age || '',
    education_TFIDB: personData.education_TFIDB || '',
    height: personData.height || '',
    readMoreAboutLink: personData.readMoreAboutLink || '',
    // firstMovie: personData.firstMovie || [],
    // firstSuccessfulMovie: personData.firstSuccessfulMovie || [],
    hitMovies: personData.hitMovies || [],
    firstMovie: singleMovie(personData.firstMovie),
    firstSuccessfulMovie: singleMovie(personData.firstSuccessfulMovie),
    personArticleReviewTitle_En: personData.personArticleReviewTitle_En || '',
    personArticleReviewTitle_Te: personData.personArticleReviewTitle_Te || '',
    yousayPersonReviewURL_Te: personData.yousayPersonReviewURL_Te || '',
    yousayPersonReviewURL_En: personData.yousayPersonReviewURL_En || '',
    rumours: getDataArrayStrings(personData.rumours),
    controversies: getDataArrayStrings(personData.controversies),
    awards_TFIDB: getDataArrayStrings(personData.awards_TFIDB),
    personNewsUpdates: getDataArrayStrings(personData.personNewsUpdates),
    // hitMovies:hitMovies|| [],
  }
  return inputData1
}

const getDataArrayStrings = data => (data ? data : [])
const singleMovie = movie => {
  if (movie) {
    return [movie]
  }

  return []
}

const GalleryVideos = movieDataExists => {
  if (movieDataExists.galleryVideos) {
    const galleryVideos = movieDataExists.galleryVideos.map(e => ({
      path: e.path,
      title: e.title,
      thumbnail: e.thumbnail,
      videoPlatform: e.videoPlatform ? e.videoPlatform : 'youtube',
      galleryTags: e.galleryTags ? e.galleryTags : [],
    }))
    if (galleryVideos.length > 0) {
      return galleryVideos
    }

    return []
  }
}

const GalleryImages = movieDataExists => {
  const cdnurl = AwsConfig.movieCdnUrl
  if (movieDataExists.galleryImages) {
    const galleryImages = movieDataExists.galleryImages.map(e => ({
      path: cdnurl + e.path,
      title: e.title,
      galleryTags: e.galleryTags ? e.galleryTags : [],
    }))
    if (galleryImages.length > 0) {
      return galleryImages
    }

    return []
  }
}

const reduceComplexitySecound = personData => {
  const awardsEn = personData.awards_En ? personData.awards_En.split(',') : []
  const awardsTe = personData.awards_Te
    ? personData.awards_Te.split(',')
    : new Array(awardsEn.length).fill('')
  const relativesEn = personData.relatives_En ? personData.relatives_En.split(',') : []
  const relativesTe = personData.relatives_Te
    ? personData.relatives_Te.split(',')
    : new Array(relativesEn.length).fill('')
  const spouseEn = personData.spouse_En ? personData.spouse_En.split(',') : []
  const spouseTe = personData.spouse_Te
    ? personData.spouse_Te.split(',')
    : new Array(spouseEn.length).fill('')
  const popularPerson = personData.popularPerson ? personData.popularPerson : false
  const GOAT = personData.GOAT ? personData.GOAT : false

  const popularyKnownAsEn =
    personData && personData.popularyKnownAs_En ? personData.popularyKnownAs_En : ''
  const popularyKnownAsTe =
    personData && personData.popularyKnownAs_Te ? personData.popularyKnownAs_Te : ''

  return {
    awardsEn,
    awardsTe,
    relativesEn,
    relativesTe,
    spouseEn,
    spouseTe,
    popularPerson,
    popularyKnownAsEn,
    popularyKnownAsTe,
    GOAT,
  }
}

const reduceComplexity = personData => {
  // const translatedataRelative = personData.relatives_En
  //    ? personData.relatives_En.split(',').map(e => `(${e})*`)
  //    : []
  // const translateSpouse = personData.children_En
  //    ? personData.children_En.split(',').map(e => `(${e})*`)
  //    : []
  const translatespouse = personData.spouse_En
    ? personData.spouse_En.split(',').map(e => `(${e})*`)
    : []
  const personDataoccupationEn = personData.occupation_En
    ? personData.occupation_En.split(',').map(e => ({ label: e, value: e }))
    : []
  // const personDataoccupationTe = personData.occupation_Te
  //   ? personData.occupation_Te.split(',').map(e => ({ label: e, value: e }))
  //   : []
  // select same label with different value in personoccupationtelugu corresponding to personDataoccupationEn
  const personDataoccupationTe = personDataoccupationEn.map(e => {
    // check if  e.label is present in personoccupationtelugu
    // if present then return the value of that label
    // else return the label itself

    const index = personoccupationtelugu.findIndex(object => object.label === e.label)
    if (index !== -1) {
      return personoccupationtelugu[index]
    }

    return { label: e, value: `(${e})*` }
  })
  const occupationte = []
  personDataoccupationEn.forEach(element => {
    const indexOfanElement = personoccupationtelugu.findIndex(
      occupationOption => occupationOption.label === element.label,
    )
    if (indexOfanElement > -1) {
      if (personoccupationtelugu[indexOfanElement] !== undefined) {
        occupationte.push(personoccupationtelugu[indexOfanElement])
      }
    } else {
      occupationte.push({ label: element.label, value: `${element.label}*` })
    }
  })
  // const personDataoccnotpresent = personData.occupation_En
  //   ? personData.occupation_En.split(',').map(e => ({ label: e, value: `(${e})*` }))
  //   : []
  const almamater = personData.almamater_En ? personData.almamater_En : ''
  const almamaterte = personData.almamater_Te ? personData.almamater_Te : ''
  // new Array(almamater.length).fill('')
  let posterUrl = personData.posterURL ? personData.posterURL : ''
  const PlaceofBirthen = personData.placeOfBirth_En ? personData.placeOfBirth_En : ''
  const PlaceofBirthte = personData.placeOfBirth_Te ? personData.placeOfBirth_Te : ''
  const parentsEn = personData.parents_En ? personData.parents_En.split(',') : ''
  const parentsTe = personData.parents_Te ? personData.parents_Te.split(',') : ''
  const RolesEn = personData.roles ? personData.roles /* .split(',') */ : []
  const genreEn = personData.genres_En ? personData.genres_En.split(',') : []
  const genreTe = personData.genres_Te ? personData.genres_Te.split(',') : []
  const childrenEn = personData.children_En ? personData.children_En.split(',') : []
  const childrenTe = personData.children_Te
    ? personData.children_Te.split(',')
    : new Array(childrenEn.length).fill('')
  const PoliticalPartyEn = personData.politicalParty_En
    ? personData.politicalParty_En.split(',')
    : []
  const PoliticalPartyTe = personData.politicalParty_Te
    ? personData.politicalParty_Te.split(',')
    : new Array(PoliticalPartyEn.length).fill('')
  const cdnurl = AwsConfig.movieCdnUrl
  // console.log(cdnurl, 'this is cdnurlllll')
  // console.log(posterUrl, 'this is uriiiiiiiiiii')
  if (posterUrl && !posterUrl.includes(cdnurl)) {
    posterUrl = cdnurl + posterUrl
    // console.log(uri, 'this is inside if condition')
  }

  return {
    PlaceofBirthen,
    PlaceofBirthte,
    // translatedataRelative,
    // translateSpouse,
    translatespouse,
    personDataoccupationEn,
    personDataoccupationTe,
    occupationte,
    // personDataoccnotpresent,
    almamater,
    almamaterte,
    posterUrl,
    parentsEn,
    parentsTe,
    RolesEn,
    genreEn,
    genreTe,
    PoliticalPartyEn,
    PoliticalPartyTe,
    childrenEn,
    childrenTe,
  }
}

export default PersonDataforForm
